import { SelectionPage } from 'app/BCKSPage/SelectionPage'
import { fetchCartoolPageContentManager } from 'utils/cartoolContentManager'

import type { CartoolContentManagerPayloadType } from 'utils/cartoolContentManager'
import type { PMMKSInvitationPageContentType } from 'app/BCKSPage/Invitation/ModelBCKSContentPage'

export async function getStaticProps() {
  const cartoolContentPayload: CartoolContentManagerPayloadType = {
    pageName: 'PMMKSInvitationPage',
  }

  const { textContent = {}, dataContent = {} } =
    await fetchCartoolPageContentManager(cartoolContentPayload)

  return {
    props: {
      textContent,
      dataContent,
    },
  }
}

const SelectionPageIndex = (props: PMMKSInvitationPageContentType) => {
  const { textContent, dataContent } = props
  return <SelectionPage textContent={textContent} dataContent={dataContent} />
}

// eslint-disable-next-line react/display-name
SelectionPageIndex.Layout = ({ children }) => children

export default SelectionPageIndex
